import { render, staticRenderFns } from "./RoomAccesoriesSelect.vue?vue&type=template&id=548e5ca2&"
import script from "./RoomAccesoriesSelect.vue?vue&type=script&lang=js&"
export * from "./RoomAccesoriesSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports